import { Tooltip } from 'antd'
import AntdAvatar from 'components/Avatar'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import { AlertText, StyledAlert } from 'components/UIComponents/FormStyles'
import AlertIconYellow from 'components/icons/AlertIconYellow'
import DriveStatus from 'modules/Roles/ViewRole/TwoDriveDrawer/DriveStatus/index'
import Tags from 'modules/Roles/ViewRole/TwoDriveDrawer/Tags/index'
import DriveActionDropdown from 'modules/Roles/ViewRole/TwoDriveDrawer/TwoDriveTable/Actions/index'
import { DriveSpan } from 'modules/Roles/ViewRole/TwoDriveDrawer/TwoDriveTable/style'
import React from 'react'
import { getDay } from 'utils/getDay'
import { getIdFormate } from 'utils/getZeroBeforeInt'

const renderExpandedRowRender = () => (
  <StyledAlert
    message={<AlertText>Multiple roles mapped under this drive ID.</AlertText>}
    type="warning"
    showIcon
    icon={<AlertIconYellow />}
  />
)

const TwoDriveTable = ({
  loading,
  driveList,
  pageLimit,
  setPageNum,
  getDriveRoleMetrics,
  driveRoleMetrics,
  setTwoDriveDrawer,
}) => {
  const onPageChange = value => {
    setPageNum(value)
  }

  const columns = [
    {
      width: 250,
      title: 'DRIVE NAME',
      dataIndex: 'id',

      render: (_, data) => (
        <Flex column>
          <RowNumberData>{getIdFormate(data?.serialNo)}</RowNumberData>

          <DriveSpan>
            <DriveSpan bold="true">
              {' '}
              {data?.name ? `${'(' + data?.name + ')'}` : ''}{' '}
            </DriveSpan>
            {data?.driveMode?.split('_')?.join(' ')?.toLowerCase()}
          </DriveSpan>
        </Flex>
      ),
    },
    {
      width: 250,
      title: 'College(s)',
      dataIndex: 'hostCollegeName',
      render: (_, data) => (
        <FlexWrap alignCenter gap="8px">
          {data?.driveMode == 'VIRTUAL_DRIVE' ? (
            <Tooltip title="Virtual">Virtual</Tooltip>
          ) : (
            <>
              <AntdAvatar
                size={25}
                IconName={data?.hostCollegeName?.split('')[0]}
              />
              <RowNumberData>
                <Tooltip title={data?.hostCollegeName}>
                  {data?.hostCollegeName?.length > 16
                    ? data?.hostCollegeName?.substr(0, 16) + '...'
                    : data?.hostCollegeName}
                </Tooltip>
              </RowNumberData>
            </>
          )}

          {data?.driveRoleMap?.length > 1 ? (
            <Tags tagsData={data?.driveRoleMap} />
          ) : null}
        </FlexWrap>
      ),
    },
    {
      title: 'Requested',
      dataIndex: 'createdAt',
      render: requestedAt => (
        <Flex centerVertically>
          <RowNumberData>
            {requestedAt ? getDay(requestedAt, true) : '-'}
          </RowNumberData>
        </Flex>
      ),
    },
    {
      title: 'status',
      dataIndex: 'corporateStatus',
      render: status => <DriveStatus status={status} />,
    },

    {
      width: 150,
      title: 'Scheduled',
      dataIndex: 'startDate',
      render: (_, data) => (
        <RowNumberData>
          {data?.startDate
            ? data?.endDate
              ? `${getDay(data?.startDate, true)} - ${getDay(
                  data?.endDate,
                  true
                )}`
              : getDay(data?.startDate, true)
            : '-'}
        </RowNumberData>
      ),
    },

    {
      width: 100,
      title: 'Action',
      dataIndex: 'id',
      render: (_, data) => (
        <DriveActionDropdown
          driveData={data}
          getDriveRoleMetrics={getDriveRoleMetrics}
          driveRoleMetrics={driveRoleMetrics}
          setTwoDriveDrawer={setTwoDriveDrawer}
        />
      ),
    },
  ]
  return (
    <div>
      <StyledTable
        rowKey="id"
        columns={columns}
        dataSource={driveList?.list}
        loading={loading}
        pagination={false}
        expandedRowPadding={'5px'}
        expandable={{
          defaultExpandAllRows: true,
          showExpandColumn: false,
          expandedRowRender: record => renderExpandedRowRender(),
          rowExpandable: record => record?.driveRoleMap?.length > 1,
        }}
      />
      <Pagination
        onChange={onPageChange}
        totalPages={driveList?.totalPages * 10}
        pageSize={pageLimit}
      />
    </div>
  )
}

export default TwoDriveTable
